export const USER_LOGOUT = 'USER_LOGOUT';

const logoutEvent = new CustomEvent(USER_LOGOUT);

export const dispatchLogoutEvent = (): void => {
  window.dispatchEvent(logoutEvent);
};
